import Search from 'semantic-ui-react/dist/es/modules/Search';
import './Search.css';

export default Search;
